import { render, staticRenderFns } from "./statisDataMobile.vue?vue&type=template&id=4d0136b2&scoped=true"
import script from "./statisDataMobile.vue?vue&type=script&lang=js"
export * from "./statisDataMobile.vue?vue&type=script&lang=js"
import style0 from "./statisDataMobile.vue?vue&type=style&index=0&id=4d0136b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0136b2",
  null
  
)

export default component.exports